<script lang="ts">
  import type {IRollover} from "$lib/interfaces/IRollover";
  import {userService} from "$lib/services/user.service";
  import {onMount} from "svelte";
  import {dialogData} from "$lib/stores/dialogStores";
  import NumberFormat from "$lib/components/NumberFormat.svelte";
  import RolloverStatus from "$lib/components/RolloverStatus.svelte";
  import {translate} from "$lib/i18n";
  import { format, parseISO } from "date-fns";

  let rolloverDetails: IRollover;
  let promise: any = null;
  let data: any;

  onMount(() => {
    dialogData.subscribe(value => {
      if (value.RolloverDetailsModal) {
        data = value.RolloverDetailsModal;
      }
    });
    promise = getTournaments();
  });

  async function getTournaments() {
    console.log(data.data);
    await userService.getUserWagerById(data.id).then((response: any) => {
      if (response) {
        return response.data;
      }
      throw new Error('Failed to fetch tournaments');
    }).then(data => {
      rolloverDetails = data.data;
      return rolloverDetails;
    }).catch(err => {
      console.error(err);
    });
  }

</script>

<div class="flex flex-col gap-5 overflow-y-auto max-h-[90vh] no-scrollbar text-white">
  <h3>Rollover Details</h3>
  {#await promise}
    <div class="min-h-[36vh] flex justify-center items-center col-span-full">
      <enhanced:img src="$lib/logo.svg?enhanced" class="animate-bounce" width="140" alt="Forza.bet"/>
    </div>
  {:then data}
    {#if rolloverDetails}
      <div class="flex justify-center font-bold">
        <img src="/currencies/{rolloverDetails.transaction.cryptoCurrency.name.toLocaleLowerCase()}.png"
             class="w-6 mr-2" alt={rolloverDetails.transaction.cryptoCurrency.name}>
        +{rolloverDetails.transaction.amount} {rolloverDetails.transaction.cryptoCurrency.shortName}
      </div>
      <div class="bg-primary-dark p-4 rounded-xl text-sm">
        <div class="flex flex-col gap-4">
          <div class="flex justify-between"><span>{$translate('Status')}:</span>
            <RolloverStatus status={rolloverDetails.status}/>
          </div>
          <div class="flex justify-between"><span>{$translate('Type')}:</span> {rolloverDetails.type}</div>
          <div class="flex justify-between border-b border-primary-lightBlue pb-4"><span>{$translate('Created on')}
            :</span> {format(parseISO(rolloverDetails.createdAt),'MMM d, yyyy')} </div>
          <div class="flex justify-between"><span>{$translate('Rollover Times')}
            :</span> {rolloverDetails.wagerMultiplier}x
          </div>
          <div class="flex justify-between"><span>{$translate('Total Wager Required')}:</span> $
            <NumberFormat
                value={(rolloverDetails.progress?.wageredInUsd ?? 0) + (rolloverDetails.progress?.wageringLeftInUsd ?? 0)}
                digitsInfo="1.2-2"/>
          </div>
          <div class="flex justify-between"><span>{$translate('Wager Completed')}:</span> $
            <NumberFormat value={rolloverDetails.progress?.wageredInUsd ?? 0} digitsInfo="1.2-2"/>
          </div>
          <div class="flex justify-between"><span>{$translate('Wager Left')}:</span> $
            <NumberFormat value={rolloverDetails.progress?.wageringLeftInUsd ?? 0} digitsInfo="1.2-2"/>
          </div>
          <div class="w-full h-4 bg-primary-lightBlue rounded-full overflow-hidden relative">
            <span
                class="flex justify-center absolute left-1/2 -translate-x-1/2 text-xs">{rolloverDetails.progress?.wagerPercentage}
              %</span>
            <div class="h-full bg-primary-fire rounded-full"
                 style="width: {rolloverDetails.progress?.wagerPercentage}%"></div>
          </div>
        </div>
      </div>
    {/if}
  {/await}
</div>
